import React from "react";
import { useLanguage } from "../context/LanguageContext";

export default function LanguageSwitcher() {
  const { lang, setLang } = useLanguage();

  return (
    <div className="mb-8 flex justify-center gap-4">
      <button
        onClick={() => setLang("en")}
        className={`rounded px-4 py-2 ${
          lang === "en" ? "bg-indigo-600 text-white" : "border bg-white text-indigo-600"
        }`}
      >
        EN
      </button>
      <button
        onClick={() => setLang("ua")}
        className={`rounded px-4 py-2 ${
          lang === "ua" ? "bg-indigo-600 text-white" : "border bg-white text-indigo-600"
        }`}
      >
        UA
      </button>
    </div>
  );
}
